import { BrokerStatus, StatusForBroker } from "@dune/types";
import { brokerStatusStyles } from "@dune/utils";

export const BrokerStatusBadge = ({ status }: { status: BrokerStatus }) => {
	return (
		<span
			className={`px-2 py-1 rounded-full text-xs font-medium border ${brokerStatusStyles[status]}`}
		>
			{StatusForBroker[status]}
		</span>
	);
};
